$(document).ready(function () {
    var hostname = window.location.hostname;
    var urlAdd = "https://" + hostname + "/apps/api/wishlist/add";
    var urlDelete = "https://" + hostname + "/apps/api/wishlist/delete";
    //Wishlist for product
    $('#wishlistAction').on('click', '#addWishlist', function(e){
        e.preventDefault();
        $("#wishlistAction").html('');
        $("#wishlistAction").html('<a id="loading"><span>読み込み中</span></a>');
        var customerId = $(this).attr("data-customer");
        var productId = $(this).attr("data-product");
        if (customerId === "" || typeof customerId === "undefined" || productId === "" || typeof productId === "undefined") {
            swal({
                title: "エラー",
                text: "ウィッシュリストアイテムはありません",
                icon: "error",
            });
            return false;
        }
        $.ajax({
            type: "POST",
            url: urlAdd,
            data: {
                customer_id: customerId,
                item_id: productId,
                type: "products"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    var html = '<a href="#" id="deleteWishlist" data-customer="' + customerId + '" data-product="' + productId + '"><span>マイカタログから削除する</span></a>';
                    $("#wishlistAction").html('');
                    $("#wishlistAction").html(html);
                } else {
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $('#wishlistAction').on('click', '#deleteWishlist', function(e){
        e.preventDefault();
        $("#wishlistAction").html('');
        $("#wishlistAction").html('<a id="loading"><span>読み込み中</span></a>');
        var customerId = $(this).attr("data-customer");
        var productId = $(this).attr("data-product");
        if (customerId === "" || typeof customerId === "undefined" || productId === "" || typeof productId === "undefined") {
            swal({
                title: "エラー",
                text: "ウィッシュリストアイテムはありません",
                icon: "error",
            });
            return false;
        }
        $.ajax({
            type: "POST",
            url: urlDelete,
            data: {
                customer_id: customerId,
                item_id: productId,
                type: "products"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    var html = '<a href="#" id="addWishlist" data-customer="' + customerId + '" data-product="' + productId + '"><span>マイカタログに登録する</span></a>';
                    $("#wishlistAction").html('');
                    $("#wishlistAction").html(html);
                } else {
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $(document).on('click', '.add-wishlist', function(e){
        e.preventDefault();
        var customerId = $(this).attr("data-customer");
        var productId = $(this).attr("data-product");
        if (customerId === "" || typeof customerId === "undefined" || productId === "" || typeof productId === "undefined") {
            swal({
                title: "エラー",
                text: "ウィッシュリストアイテムはありません",
                icon: "error",
            });
            return false;
        }
        let actionWishlist = $(".wishlist-" + productId);
        actionWishlist.html('');
        actionWishlist.html('<a class="loading"><span>読み込み中</span></a>');
        $.ajax({
            type: "POST",
            url: urlAdd,
            data: {
                customer_id: customerId,
                item_id: productId,
                type: "products"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    var html = '<a href="#" class="delete-wishlist" data-customer="' + customerId + '" data-product="' + productId + '"><span>マイカタログから削除する</span></a>';
                    actionWishlist.html('');
                    actionWishlist.html(html);
                } else {
                    swal({
                   title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $(document).on('click', '.delete-wishlist', function(e){
        e.preventDefault();
        var customerId = $(this).attr("data-customer");
        var productId = $(this).attr("data-product");
        if (customerId === "" || typeof customerId === "undefined" || productId === "" || typeof productId === "undefined") {
            swal({
                title: "エラー",
                text: "ウィッシュリストアイテムはありません",
                icon: "error",
            });
            return false;
        }
        let actionWishlist = $(".wishlist-" + productId);
        actionWishlist.html('');
        actionWishlist.html('<a class="loading"><span>読み込み中</span></a>');
        $.ajax({
            type: "POST",
            url: urlDelete,
            data: {
                customer_id: customerId,
                item_id: productId,
                type: "products"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    var html = '<a href="#" class="add-wishlist" data-customer="' + customerId + '" data-product="' + productId + '"><span>マイカタログに登録する</span></a>';
                    actionWishlist.html('');
                    actionWishlist.html(html);
                } else {
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $('.add-grid-wishlist').click(function(e) {
        e.preventDefault();
        $(this).hide();
        var customerId = $(this).attr("data-customer");
        var productId = $(this).attr("data-product");
        if (customerId === "" || typeof customerId === "undefined" || productId === "" || typeof productId === "undefined") {
            swal({
                title: "エラー",
                text: "続行するにはログインしてください",
                icon: "info",
            });
            window.scrollTo({top: 0, behavior: 'smooth'});
            return false;
        }
        $.ajax({
            type: "POST",
            url: urlAdd,
            data: {
                customer_id: customerId,
                item_id: productId,
                type: "products"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    swal({
                       title: "Thank you!",
                       text: "この商品をマイカタログに追加しました。",
                       icon: "success",
                    });
                } else {
                    $(this).show();
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                $(this).show();
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    // Bookmark for article
    $('#main').on('click', '.add-bookmark', function(e) {
        e.preventDefault();
        $(this).hide();
        var customerId = $(this).attr("data-customer");
        var articleId = $(this).attr("data-article");
        if (customerId === "" || typeof customerId === "undefined" || articleId === "" || typeof articleId === "undefined") {
            swal({
                title: "エラー",
                text: "続行するにはログインしてください",
                icon: "info",
            });
            window.scrollTo({top: 0, behavior: 'smooth'});
            return false;
        }
        $.ajax({
            type: "POST",
            url: urlAdd,
            data: {
                customer_id: customerId,
                item_id: articleId,
                type: "articles"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    swal({
                       title: "Thank you!",
                       text: "この記事をお気に入りに追加しました。",
                       icon: "success",
                    });
                } else {
                    $(this).show();
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                $(this).show();
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $('#iconBookmark').click(function(e) {
        e.preventDefault();
        $('#btnBookmark').trigger('click');
    });

    $('#btnBookmark').click(function(e) {
        e.preventDefault();
        var customerId = $(this).attr("data-customer");
        var articleId = $(this).attr("data-article");
        var elIcon = $('#iconBookmark');
        if (customerId === "" || typeof customerId === "undefined" || articleId === "" || typeof articleId === "undefined") {
            swal({
                title: "エラー",
                text: "続行するにはログインしてください",
                icon: "info",
            });
            window.scrollTo({top: 0, behavior: 'smooth'});
            return false;
        }
        var bookmarkAction = $("#bookmarkAction");
        bookmarkAction.html('');
        bookmarkAction.html('<a class="loading">読み込み中</a>');
        elIcon.hide();
        $.ajax({
            type: "POST",
            url: urlAdd,
            data: {
                customer_id: customerId,
                item_id: articleId,
                type: "articles"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    swal({
                       title: "Thank you!",
                       text: "この記事をお気に入りに追加しました。",
                       icon: "success",
                    });
                    bookmarkAction.hide();
                } else {
                    bookmarkAction.hide();
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                bookmarkAction.hide();
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $('.del-wishlist').click(function(e) {
        e.preventDefault();
        $(this).hide();
        var customerId = $(this).attr("data-customer");
        var productId = $(this).attr("data-product");
        if (customerId === "" || typeof customerId === "undefined" || productId === "" || typeof productId === "undefined") {
            swal({
                title: "エラー",
                text: "ウィッシュリストアイテムはありません",
                icon: "error",
            });
            return false;
        }
        $.ajax({
            type: "POST",
            url: urlDelete,
            data: {
                customer_id: customerId,
                item_id: productId,
                type: "products"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    swal({
                       title: "Thank you!",
                       text: "この商品がマイカタログから削除されました。",
                       icon: "success",
                    });
                    $('#product-' + productId).remove();
                } else {
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    });

    $('.del-bookmark').click(function(e) {
        e.preventDefault();
        $(this).hide();
        var customerId = $(this).attr("data-customer");
        var atricleHandle = $(this).attr("data-article");
        var atricleId = $(this).attr("data-id");
        if (customerId === "" || typeof customerId === "undefined" || atricleHandle === "" || typeof atricleHandle === "undefined") {
            swal({
                title: "エラー",
                text: "ウィッシュリストアイテムはありません",
                icon: "error",
            });
            return false;
        }
        $.ajax({
            type: "POST",
            url: urlDelete,
            data: {
                customer_id: customerId,
                item_id: atricleHandle,
                type: "articles"
            },
            dataType: "json",
            success: function (result) {
                if (result.status === true) {
                    if ($('#main .pho').length == 1) {
                        var elParent = $('#article-' + atricleId).parent();
                        if (elParent) {elParent.html('<h4>まだ記事はありません。</h4>')};
                    }
                    swal({
                       title: "Thank you!",
                       text: "この記事はお気に入りから削除されました。",
                       icon: "success",
                    });
                    $('#article-' + atricleId).remove();
                } else {
                    swal({
                       title: "エラー",
                       text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                       icon: "error",
                    });
                }
            },
            error: function (e) {
                swal({
                   title: "エラー",
                   text: "エラー！ エラーが発生しました。 後でもう一度やり直してください",
                   icon: "error",
                });
            }
        });
    })
});